module.exports = __webpack_public_path__ + "img/headphone.75a48a76.svg";